module.exports = __webpack_public_path__ + "img/IMG_5830.82800ca6.jpg";